import * as t from 'io-ts';

import {makeApiType} from './apiTypes';
import {parseUploadedAttachment, RUploadedAttachment} from './attachmentModel';

/*
 * Runtime type.
 */

export enum AnswerFlagsEnum {
  WAS_CREATED_BY_ONBOARDING = 'was_created_by_onboarding',
}

const RAnswerDirty = t.readonly(
  t.type({
    id: t.Integer,
    url: t.string,
    namespace: t.string,
    folderId: t.union([t.undefined, t.Integer]),
    showInAllInboxes: t.boolean,
    inboxIds: t.readonlyArray(t.Integer),
    sortOrder: t.Integer,
    name: t.string,
    subject: t.union([t.undefined, t.string]),
    blurb: t.string,
    body: t.string,
    attachments: t.readonlyArray(RUploadedAttachment),
    wasCreatedByOnboarding: t.boolean,
    createdAt: t.Integer,
    updatedAt: t.Integer,
  }),
  'answer',
);

/*
 * Type.
 */

export interface AnswerModel extends t.TypeOf<typeof RAnswerDirty> {}
export const RAnswer = t.clean<AnswerModel>(RAnswerDirty as any);
const RAnswers = t.readonlyArray(RAnswer);

/*
 * IO methods.
 */

export function parseAnswer(src: any): AnswerModel {
  return {
    id: src.id,
    url: src.url,
    namespace: src.namespace,
    folderId: src.folder_id || undefined,
    showInAllInboxes: src.all_inboxes,
    inboxIds: src.inbox_ids,
    sortOrder: src.sort_order,
    name: src.name,
    subject: src.subject || undefined,
    blurb: src.blurb,
    body: src.body,
    attachments: src.attachments && src.attachments.map(parseUploadedAttachment),
    wasCreatedByOnboarding: Boolean(
      Array.isArray(src.extra) && src.extra.includes(AnswerFlagsEnum.WAS_CREATED_BY_ONBOARDING),
    ),
    createdAt: src.created_at,
    updatedAt: src.updated_at || src.created_at,
  };
}

function parseAnswers(src: any): any {
  return src.canned_answers && src.canned_answers.map(parseAnswer);
}

/*
 * API type.
 */

export const ApiAnswer = makeApiType('answer', RAnswer, parseAnswer);
export const ApiAnswers = makeApiType('answers', RAnswers, parseAnswers);
